import { mapValues } from '@exodus/basic-utils';
const atomsIdentificationPreprocessor = () => {
    const preprocess = (node) => {
        if (!['atom', 'atom-collection'].includes(String(node.definition.type)))
            return node;
        const { definition, ...rest } = node;
        const { factory: originalFactory, id, ...definitionRest } = definition;
        const factory = definition.type === 'atom'
            ? (...opts) => {
                const atom = originalFactory(...opts);
                atom.id = id;
                return atom;
            }
            :
                (...deps) => {
                    const atoms = originalFactory(...deps);
                    return mapValues(atoms, (atom, atomId) => {
                        return {
                            ...atom,
                            id: atom.id || `${id}.${atomId}`,
                        };
                    });
                };
        return {
            ...rest,
            definition: {
                ...definitionRest,
                id,
                factory,
            },
        };
    };
    return { type: 'node', preprocess };
};
export default atomsIdentificationPreprocessor;
